import { useEffect } from 'react'
import Router from './components/Router/Router.jsx'
import { I18nextProvider } from 'react-i18next'
import { i18n } from './i18n/i18n'

import './App.css'
const App = () => {
  useEffect(() => {
    window.toastr.options.progressBar = true
    window.toastr.options.closeDuration = 700
    window.toastr.options.timeOut = 10000
    window.toastr.options.extendedTimeOut = 3000
    window.toastr.options.closeButton = true
    window.toastr.options.positionClass = 'toast-bottom-right'
    window.toastr.options.showMethod = 'slideDown'
    window.toastr.options.hideMethod = 'slideUp'
    window.toastr.options.closeMethod = 'slideUp'
    window.toastr.options.closeHtml =
      '<button>x</button>'
  }, [])

  useEffect(() => {
    const prefersReducedMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches
    if (prefersReducedMotion) return undefined
    if (typeof IntersectionObserver === 'undefined') {
      document.querySelectorAll('.reveal-on-scroll').forEach((node) => {
        node.classList.add('is-visible')
      })
      return undefined
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible')
            observer.unobserve(entry.target)
          }
        })
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.15 }
    )

    const observeTargets = (root = document) => {
      const targets =
        root instanceof Element && root.classList?.contains('reveal-on-scroll')
          ? [root]
          : root.querySelectorAll('.reveal-on-scroll')

      targets.forEach((target) => {
        if (
          target.closest('nav') ||
          target.closest('footer') ||
          target.classList.contains('no-reveal')
        ) {
          return
        }
        if (!target.classList.contains('reveal-ready')) {
          target.classList.add('reveal-ready')
          if (target.matches('[class*="rounded-"], [class*="shadow-"], [class*="card"]')) {
            target.classList.add('reveal-card')
          }
          observer.observe(target)
        }
      })
    }

    observeTargets()

    const mutationObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) {
            observeTargets(node)
          }
        })
      })
    })

    mutationObserver.observe(document.body, { childList: true, subtree: true })

    const revealInViewport = () => {
      const viewportHeight = window.innerHeight || 0
      document.querySelectorAll('.reveal-on-scroll').forEach((node) => {
        const rect = node.getBoundingClientRect()
        if (rect.top < viewportHeight * 0.92 && rect.bottom > viewportHeight * 0.08) {
          node.classList.add('is-visible')
        }
      })
    }

    const failsafeTimer = setTimeout(revealInViewport, 1400)

    return () => {
      observer.disconnect()
      mutationObserver.disconnect()
      clearTimeout(failsafeTimer)
    }
  }, [])

  return (
    <div className='App'>
      <I18nextProvider i18n={i18n}>
        <Router />
      </I18nextProvider>
      <header className='App-header' />
    </div>
  )
}

export default App
